import type { ReactNode } from 'react';

export const symbol_video_template: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-40q-24 0-42-18t-18-42v-85h60v85h600v-85h60v85q0 24-18 42t-42 18H180Zm-40-205q-24 0-42-18t-18-42v-350q0-24 18-42t42-18h680q24 0 42 18t18 42v350q0 24-18 42t-42 18H140Zm-20-530v-85q0-24 18-42t42-18h600q24 0 42 18t18 42v85h-60v-85H180v85h-60Zm20 470h680v-350H140v350Zm340-175Zm-71 103 173-103-173-104v207Z"
		/>
	</svg>
);
